import React from 'react'

export default function QuizWrapper ({ children, className }) {
  return (
    <div className={`rounded-lg p-6 mb-10 max-w-auto md:w-full md:max-w-7xl ${className}`}>
        {children}
    </div>
  )
}
